import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap";

export default class extends Controller {
  connect() {
    document.querySelectorAll(".toast").forEach((toastEl) => {
      new Toast(toastEl).show();
      toastEl.addEventListener("hidden.bs.toast", function () {
        this.remove();
      });
    });
  }
}
